/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';

import { Url_License_AllLicenses, Url_License_AvailableHardware, Url_License_Compiled, Url_License_Install, Url_License_LicenseById } from 'app/rest-constants';
import { CompiledLicenseDTO } from "../models/compiled-license-dto";
import { LicenseDTO } from "../models/license-dto";
import { LicensedHardwareDTO } from "../models/licensed-hardware-dto";
import { RestService } from "./rest-service";

@Injectable()
export class LicensingService {

  constructor(
    private mRestService: RestService
  ) { }

  getAvailableHardware(): Promise<LicensedHardwareDTO[]> {
    return this.mRestService.get<LicensedHardwareDTO[]>(Url_License_AvailableHardware);
  }

  getCompiledLicense(): Promise<CompiledLicenseDTO> {
    return this.mRestService.get<CompiledLicenseDTO>(Url_License_Compiled);
  }

  getInstalledLicenses(): Promise<LicenseDTO[]> {
    return this.mRestService.get<LicenseDTO[]>(Url_License_AllLicenses);
  }

  getInstalledLicense(id: number): Promise<LicenseDTO> {
    return this.mRestService.get<LicenseDTO>(Url_License_LicenseById(id));
  }

  deleteInstalledLicense(id: number): Promise<void> {
    return this.mRestService.delete<void>(Url_License_LicenseById(id));
  }
  
  deleteInstalledLicenses(ids: number[]): Promise<void> {
    return this.mRestService.delete<void>(Url_License_AllLicenses, ids);
  }

  installLicense(formData: FormData): Promise<LicenseDTO> {
    return this.mRestService.upload<LicenseDTO>(Url_License_Install, formData);
  }

}
